import React, { useMemo } from "react";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const COLORS = ["#f59e0b", "#10b981", "#4f46e5", "#8b5cf6", "#ec4899", "#ef4444"];

const TutoCategorieChart = ({ tutosData }) => {
  const data = useMemo(() => {
    const counts = {};
    Object.values(tutosData).forEach((tuto) => {
      const key = tuto.categories || "Général";
      counts[key] = (counts[key] || 0) + 1;
    });

    return Object.entries(counts)
      .map(([name, value]) => ({ name, value }))
      .sort((a, b) => b.value - a.value);
  }, [tutosData]);

  if (data.length === 0) {
    return (
      <div className="chart">
        <p className="dash-empty">Aucun tutoriel à afficher pour le moment.</p>
      </div>
    );
  }

  return (
    <div className="chart">
      <ResponsiveContainer width="100%" height={260}>
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            innerRadius={60}
            outerRadius={90}
            paddingAngle={4}
            dataKey="value"
            stroke="#2d2d2d"
            strokeWidth={3}
          >
            {data.map((entry, index) => (
              <Cell key={entry.name} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip
            contentStyle={{
              backgroundColor: "#1f2937",
              borderRadius: "8px",
              border: "none",
              boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.5)",
              color: "#fff",
            }}
          />
          <Legend
            layout="vertical"
            verticalAlign="middle"
            align="right"
            iconType="circle"
            wrapperStyle={{ fontSize: "12px", color: "#9ca3af" }}
          />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default TutoCategorieChart;
